'use strict';

module.exports = function (ngModule) {
    ngModule.directive('makeRowChart', require('./makerowchart'));
}


/** WEBPACK FOOTER **
 ** ./src/pages/directives/rowchart/index.js
 **/